var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "     <div class=\"row cinema-divider\">\n        <div class=\"col-12\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(lookupProperty(helpers,"hasCinemaLogo")||(depth0 && lookupProperty(depth0,"hasCinemaLogo"))||container.hooks.helperMissing).call(alias1,(depth0 != null ? lookupProperty(depth0,"showSiteID") : depth0),{"name":"hasCinemaLogo","hash":{},"data":data,"loc":{"start":{"line":4,"column":18},"end":{"line":4,"column":49}}}),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":4,"column":12},"end":{"line":8,"column":19}}})) != null ? stack1 : "")
    + "        </div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <img class=\"cinema-logo\" src=\""
    + alias3(((helper = (helper = lookupProperty(helpers,"getCdn") || (depth0 != null ? lookupProperty(depth0,"getCdn") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"getCdn","hash":{},"data":data,"loc":{"start":{"line":5,"column":46},"end":{"line":5,"column":56}}}) : helper)))
    + alias3((lookupProperty(helpers,"cinemaLogo")||(depth0 && lookupProperty(depth0,"cinemaLogo"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"showSiteID") : depth0),{"name":"cinemaLogo","hash":{},"data":data,"loc":{"start":{"line":5,"column":56},"end":{"line":5,"column":86}}}))
    + "\" alt=\""
    + alias3(container.lambda((depth0 != null ? lookupProperty(depth0,"showCinema") : depth0), depth0))
    + "\">\n";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <h3>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"showCinema") : depth0), depth0))
    + "</h3>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showCinema") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "");
},"useData":true});